import { render } from "./DateTime.vue?vue&type=template&id=6dcd6680&lang=pug"
import script from "./DateTime.vue?vue&type=script&lang=ts"
export * from "./DateTime.vue?vue&type=script&lang=ts"
script.render = render

export default script